export const PROJECT_STORE = 'PROJECT_STORE';
export const PROJECT_UPDATE = 'PROJECT_UPDATE';
export const PROJECT_DESTROY = 'PROJECT_DESTROY';
